function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "stopwatch",
  d: "M26.214,10.775,27.588,9.4a1.367,1.367,0,1,0-1.934-1.934L24.28,8.841a14.675,14.675,0,0,0-8.1-3.354V2.735H17.5A1.368,1.368,0,0,0,17.5,0H12.125a1.368,1.368,0,0,0,0,2.735h1.322V5.488a14.815,14.815,0,1,0,12.766,5.288ZM14.815,32.32A12.08,12.08,0,1,1,26.9,20.24,12.094,12.094,0,0,1,14.815,32.32ZM21.153,13.9a1.367,1.367,0,0,1,0,1.934l-5.371,5.371a1.367,1.367,0,1,1-1.934-1.934l5.37-5.371A1.368,1.368,0,0,1,21.153,13.9Zm0,0",
  transform: "translate(0 0)",
  fill: "#676767"
});

var SvgIcClock = function SvgIcClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.63,
    height: 35.055,
    viewBox: "0 0 29.63 35.055",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clock.6447248d.svg";
export { ForwardRef as ReactComponent };